import React from 'react';
import styled from 'styled-components';

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const ModalContent = styled.div`
  background-color: var(--clr-bg);
  border-radius: 12px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const Title = styled.h2`
  color: var(--clr-sec);
  margin: 0 0 1rem 0;
  font-size: 1.5rem;
`;

const MessagePreview = styled.div`
  background-color: var(--clr-prim);
  border-radius: 8px;
  padding: 1rem;
  margin: 1rem 0;
`;

const UserInfo = styled.div`
  color: var(--clr-purple);
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
`;

const MessageText = styled.p`
  color: var(--clr-sec);
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.8;
  max-height: 100px;
  overflow-y: auto;
  word-wrap: break-word;
`;

const WarningText = styled.p`
  color: var(--clr-sec);
  margin: 1rem 0;
  font-size: 0.95rem;
  line-height: 1.5;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;

  &:hover {
    transform: translateY(-2px);
  }
`;

const CancelButton = styled(Button)`
  background-color: var(--clr-tert);
  color: var(--clr-sec);

  &:hover {
    background-color: var(--clr-prim);
  }
`;

const BlockButton = styled(Button)`
  background-color: #ff4444;
  color: white;

  &:hover {
    background-color: #dd3333;
  }
`;

function BlockConfirmationModal({ isOpen, onClose, onConfirm, message }) {
  if (!isOpen || !message) return null;

  const handleConfirm = () => {
    onConfirm(message);
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalBackdrop onClick={handleBackdropClick}>
      <ModalContent>
        <Title>Block User?</Title>
        
        <MessagePreview>
          <UserInfo>
            {message.nickname || 'Anonymous'} 
            {message.age && ` • ${message.age}`}
            {message.pronouns && ` • ${message.pronouns}`}
          </UserInfo>
          <MessageText>{message.messageText}</MessageText>
        </MessagePreview>

        <WarningText>
          Are you sure you want to block this user? You will no longer see their messages.
          You can unblock them later from the Settings menu.
        </WarningText>

        <ButtonContainer>
          <CancelButton onClick={onClose}>Cancel</CancelButton>
          <BlockButton onClick={handleConfirm}>Block User</BlockButton>
        </ButtonContainer>
      </ModalContent>
    </ModalBackdrop>
  );
}

export default BlockConfirmationModal;